/*
pics 图片list [{src: ''tets.jpg}]
imgWidth={92}  导航图片的宽度
dotsTotalWidth={400}  导航图片总宽
selectNum={0}  默认选中那个图片
gap={90} 大图和导航图片之间的距离
btnList: [
                {
                    label: '下载',
                    onClick: this.onDownload
                },
                {
                    label: '查看',
                    onClick: this.onDownload
                }
            ]  gap 之间的 btn
navNum={4} 总共显示几个导航图片
*/
import './index.scss';
import { Button, Carousel, Image } from 'antd';
import SlickArrowLeft from '&/components/Carousel/SlickArrowLeft';
import SlickArrowRight from '&/components/Carousel/SlickArrowRight';
import React, { Component } from 'react';
export default class MyCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            carouselBig: null,
            carouselSmall: null,
        };
    }
    componentDidMount() {
        this.setState({
            carouselBig: this.carouselBigRef,
            carouselSmall: this.carouselSmallRef,
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.selectNum !== this.props.selectNum) {
            this.carouselBigRef &&
                this.carouselBigRef.innerSlider.slickGoTo(this.props.selectNum);
        }
    }

    render() {
        console.log('this.prps.hide', this.props.hideNav);
        const smallPics = this.props.smallPics || this.props.pics;
        return (
            <>
                <Carousel
                    {...this.props}
                    ref={carouselBigRef =>
                        (this.carouselBigRef = carouselBigRef)
                    }
                    className="carouselBig"
                    adaptiveHeight
                    initialSlide={this.props.selectNum || 0}
                    asNavFor={this.state.carouselSmall}>
                    {this.props.pics.map((obj, index) => {
                        return (
                            <Image
                                onClick={e =>
                                    this.props.handleImageClick &&
                                    this.props.handleImageClick(e, index, obj)
                                }
                                preview={false}
                                key={index}
                                src={obj.img}
                            />
                        );
                    })}
                </Carousel>
                <div
                    style={{
                        height: (this.props.gap || 20) / 16 + 'rem',
                        lineHeight: (this.props.gap || 20) / 16 + 'rem',
                        display: this.props.hideNav ? 'none' : 'block',
                    }}
                    className="carousel-btn-wrap">
                    {this.props.btnList &&
                        this.props.btnList.map((item, index) => {
                            return (
                                <Button
                                    key={index}
                                    onClick={() => item.onClick(item, index)}>
                                    {item.label}
                                </Button>
                            );
                        })}
                </div>
                <div
                    className="dots-wrap"
                    style={{
                        height: this.props.imgWidth / 16 + 'rem',
                        width: this.props.dotsTotalWidth / 16 + 'rem',
                    }}>
                    {this.props.hideNav ? null : (
                        <Carousel
                            ref={carouselSmallRef =>
                                (this.carouselSmallRef = carouselSmallRef)
                            }
                            arrows
                            dots={false}
                            initialSlide={this.props.selectNum || 0}
                            className="carouselSmall"
                            asNavFor={this.state.carouselBig}
                            prevArrow={<SlickArrowLeft />}
                            nextArrow={<SlickArrowRight />}
                            slidesToShow={
                                this.props.navNum ||
                                Math.floor(
                                    this.props.dotsTotalWidth /
                                        (this.props.imgWidth +
                                            (this.props.navGap
                                                ? this.props.navGap
                                                : 0))
                                )
                            }
                            swipeToSlide={true}
                            focusOnSelect={true}>
                            {smallPics.map((obj, index) => {
                                return (
                                    <Image
                                        preview={false}
                                        key={index}
                                        src={obj.img}
                                    />
                                );
                            })}
                        </Carousel>
                    )}
                </div>
            </>
        );
    }
}
